// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const result = objectOf({
  info: string,
  info_header: string,
  undo_identifier: string,
  undo_data: objectOf({
    app_group_id: string,
    segment_ids: arrayOf(string),
    campaigns_to_unarchive: arrayOf(string),
    cards_to_unarchive: arrayOf(string),
    workflows_to_unarchive: arrayOf(string),
    reenable_analytics: arrayOf(string),
    type: string,
  }),
});

const undoResult = objectOf({
  info: string,
});

export const isEngagementSegmentsMarkAsArchivedResult = anyOf(result, undoResult);
